import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  signal,
} from "@angular/core";
import * as Highcharts from "highcharts";
import { HC_LEGEND_STYLE, HC_COLORS } from "../highcharts-shared";
import { HighchartsChartComponent } from "highcharts-angular";
import { InfoComponent } from "src/app/components/info/info.component";

import { ChartPlaceholderComponent } from "src/app/components/chart-placeholder/chart-placeholder.component";

@Component({
  selector: "app-risk-contribution-column-chart",
  templateUrl: "./risk-contribution-column-chart.component.html",
  styleUrls: ["./risk-contribution-column-chart.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [HighchartsChartComponent, InfoComponent, ChartPlaceholderComponent],
  standalone: true,
})
export class RiskContributionColumnChartComponent implements OnInit {
  loaded = signal(false);
  Highcharts: typeof Highcharts = Highcharts;

  @Input() riskContributionRaw: any = {};
  @Input() subHeader: any = {};

  chartOptions: Highcharts.Options = {};
  chartType: string = "risk";
  series: any[] = [];
  name: string = "";
  ngOnInit(): void {
    this.setRiskData();
  }

  ngOnChanges(): void {
    this.setRiskData();
  }

  changeDataRC() {
    if (this.chartType === "risk") {
      this.setRiskData();
    } else {
      this.setReturnData();
    }
  }

  private setRiskData() {
    this.series = [];
    this.riskContributionRaw.sort((a, b) => {
      return b.riskContribution - a.riskContribution;
    });
    this.name = "Risk";
    this.series.push(
      {
        type: "column",
        name: "Weight",
        color: HC_COLORS.pos,
        data: this.riskContributionRaw.map((e) => e.Weight),
        pointPadding: 0.3,
      },
      {
        type: "column",
        name: "Risk",
        color: HC_COLORS.accent,
        data: this.riskContributionRaw.map((e) => e.riskContribution),
        pointPadding: 0.4,
      },
    );
    this.initChart();
  }

  private setReturnData() {
    this.series = [];
    this.riskContributionRaw.sort((a, b) => {
      return b.Return - a.Return;
    });
    this.name = "Return";
    this.series.push(
      {
        type: "column",
        name: "Weight",
        color: HC_COLORS.pos,
        data: this.riskContributionRaw.map((e) => e.Weight),
        pointPadding: 0.3,
      },
      {
        type: "column",
        name: "Return",
        color: HC_COLORS.accent,
        data: this.riskContributionRaw.map((e) => e.Return),
        pointPadding: 0.4,
      },
    );
    this.initChart();
  }

  private initChart() {
    this.loaded.set(false);

    this.chartOptions = {
      chart: {
        height: 380,
        type: "column",
        backgroundColor: "transparent",
        spacing: [12, 4, 8, 4],
        style: { fontFamily: "Inter, system-ui, sans-serif" },
      },
      credits: { enabled: false },
      title: { text: "" },

      legend: {
        enabled: true,
        align: "left",
        verticalAlign: "bottom",
        layout: "horizontal",
        itemDistance: 18,
        margin: 12,
        padding: 0,
        symbolRadius: 2,
        symbolHeight: 3,
        symbolWidth: 14,
        squareSymbol: false,
        ...HC_LEGEND_STYLE,
      },
      yAxis: {
        title: {
          text: this.name,
          style: {
            color: "var(--text-dim)",
            fontSize: "11px",
            fontWeight: "500",
          },
        },
        gridLineColor: "var(--border)",
        gridLineDashStyle: "ShortDash",
        gridLineWidth: 1,
        labels: { format: "{value}%", style: { color: "var(--text-dim)" } },
        minorGridLineWidth: 0,
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0,
          borderRadius: 3,
        },
        series: {
          label: { enabled: false },
        },
      },
      xAxis: {
        categories: this.riskContributionRaw.map((e) => e.Ticker),
        lineColor: "transparent",
        tickColor: "transparent",
        minorGridLineWidth: 0,
        gridLineWidth: 0,
        labels: { style: { color: "var(--text-dim)" } },
      },
      tooltip: {
        valueSuffix: "%",
        valueDecimals: 2,
      },
      series: this.series,
    };

    setTimeout(() => {
      this.loaded.set(true);
    });
  }
}
